module.exports = __webpack_public_path__ + "media/src/site/images/rocket-9202f5d004d4633d34bdff086712054d.gif";